export const m = {
  download: '下载歌曲',
  moreLyrics: '查看完整歌词'
}
